import { gql, useQuery } from '@apollo/client';

import type {
  GetModelArchitecturesQuery,
  GetModelArchitecturesQueryVariables,
} from '@sbrc/gql/apollo-codegen';

const GET_MODEL_ARCHITECTURES = gql`
  query GetModelArchitectures {
    getModelArchitectures {
      items {
        id
        name
      }
    }
  }
`;

export type ModelArchitectureOption = {
  id: string;
  name: string;
};

export function useModelArchitectures() {
  const { data, loading, error } = useQuery<
    GetModelArchitecturesQuery,
    GetModelArchitecturesQueryVariables
  >(GET_MODEL_ARCHITECTURES, {
    fetchPolicy: 'cache-and-network',
  });

  const items: ModelArchitectureOption[] =
    data?.getModelArchitectures?.items?.map((item) => ({
      id: item.id,
      name: item.name,
    })) ?? [];

  return { items, loading, error };
}
